import { useQuery } from "@apollo/client";
import Box from "@material-ui/core/Box";
import List from "@material-ui/core/List";
import Slide from "@material-ui/core/Slide";
import React from "react";
import { filterResources } from "../components/Chain";
import { ResourceRollupStatusListItem, ROLLUP_STATUS_QUERY } from "../components/Resource";

export function ResourceList({ group }: { group: string }) {
  const { data } = useQuery(ROLLUP_STATUS_QUERY);
  const filtered = filterResources(data?.chainRollupStatuses, group);

  return (
    <List>
      {filtered.map((resource: any, i: any) => (
        <Slide
          direction="up"
          in={true}
          timeout={Math.min(i * 200, 10 * 200)}
          key={resource.name}
        >
          <Box mb={2}>
            <ResourceRollupStatusListItem {...resource} />
          </Box>
        </Slide>
      ))}
    </List>
  );
}
